import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { IPageHeader } from '../../../../Components/pageheader/pageHeader.model';
import { PageheaderComponent } from '../../../../Components/pageheader/pageheader.component';
import { ArticlesViewComponent } from '../../../../Components/articles-view/articles-view.component';
import { BaseComponent } from '../../../base.component';
import { IPopup } from '../../../../Components/popup/popup.model';
import { AutoUnsubscribe } from '../../../../Services/autoUnsubscribe.service';
import { SchoolApiService } from '../../../../Services/schoolApi.service';
import {
  DOMAIN_TYPE,
  NATIONAL_PAGES,
  SCHEMA_TYPE,
} from '../../../../constants';
import { IList } from '../../../../Models/list.model';
import { IResponse } from '../../../../Models/response.model';
import { ISchoolArticle } from '../../../../Models/schoolArticle.model';

@AutoUnsubscribe()
@Component({
  selector: 'app-archive',
  standalone: true,
  imports: [PageheaderComponent, ArticlesViewComponent],
  providers: [SchoolApiService],
  templateUrl: './archive.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArchiveComponent extends BaseComponent {
  public pageOptions: IPageHeader = {
    mainPage: { title: 'media_center', path: '/mediacenter' },
    children: [{ title: 'archive', path: null }],
  };

  public archiveArticlesArray: IPopup[] = [];
  public start: number = 0;
  public limit: number = 10;
  public totalcount: number;

  constructor(
    override readonly schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef,
  ) {
    super(schoolApiService);
    this.domainType = DOMAIN_TYPE.NATIONAL;
    this.schemaType = SCHEMA_TYPE.MEDIA;
    this.articleType = NATIONAL_PAGES.MEDIA.ARCHIVE;
  }

  ngOnInit(): void {
    this.onPaginateEvent(0);
  }

  onPaginateEvent($event: number) {
    this.start = $event;
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: this.start,
        limit: this.limit,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.totalcount = data.payload?.count || 0;
          this.archiveArticlesArray = this.mapArticles(
            data.payload?.list || [],
          );
          this.cdr.detectChanges();
        }
      });
  }
}
